import { render, staticRenderFns } from "./global-view.vue?vue&type=template&id=5b0d8980"
import script from "./global-view.vue?vue&type=script&lang=js"
export * from "./global-view.vue?vue&type=script&lang=js"
import style0 from "./global-view.vue?vue&type=style&index=0&id=5b0d8980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports